import { due, seenLabel, type RadarView } from "../lib/radar";
import { ChevronRight, Radio } from "lucide-react";
import type { Job } from "../types/job";

interface SignalQueueProps {
  jobs: Job[];
  view: RadarView;
  onSelect: (job: Job) => void;
}

export function SignalQueue({ jobs, onSelect, view }: SignalQueueProps) {


  return (
    <aside className="signal-queue" aria-label="Live job signals">
      <div className="signal-queue-heading"><Radio size={13} /> {view} · {jobs.length}</div>
      {!jobs.length && <p className="radar-note">{view === "Apply Now" ? "No verified actionable matches yet. Check All signals for roles needing review, or refresh the employer feeds." : "No roles in this view yet."}</p>}
      <div className="signal-queue-list">
        {jobs.map((job) => (
          <button key={job.id} type="button" onClick={() => onSelect(job)}>
            <span>
              <strong>{job.title}</strong>
              <small className="radar-score">{job.radar ? `${job.radar.score} priority · ${job.radar.components.fit} fit` : "Unscored simulation"} · {seenLabel(job)}</small>
              <small>{job.company} · {job.location.region ?? job.location.country ?? "Remote"}</small>
              {job.pipeline && <small>{job.pipeline.stage}{due(job) ? " · Follow-up due" : ""}{job.pipeline.nextAction ? ` · ${job.pipeline.nextAction}` : ""}</small>}
            </span>
            <ChevronRight size={15} />
          </button>
        ))}
      </div>
      <div className="signal-queue-more">{view === "Apply Now" ? "Daily top 15 · review eligibility before applying" : "Select a role to manage your next action"}</div>
    </aside>
  );
}
